import Main from './Main'

Main.install = function (Vue) {
  Vue.component(Main.name, Main)
}

export default Main
